// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/badge-dollar-sign.js';

import { paths } from '../generated/badge-dollar-sign';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('badge-dollar-sign', Original, paths);
